import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionFeaturesComponent } from './component/section-features.component';
import { SectionValuesModule } from '../section-values/section-values.module';



@NgModule({
  declarations: [
    SectionFeaturesComponent
  ],
  imports: [
    CommonModule,
    SectionValuesModule
  ]
})
export class SectionFeaturesModule { }
